import React from 'react';
import { isEmpty } from 'lodash';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import classnames from 'classnames';
import { SafetyEntities } from 'client/data/models/safety';
import { safetyMap } from 'client/data/models/safety-map';

export function SafetyIihsRatings({ iihsRatings }) {
  if (isEmpty(iihsRatings)) {
    return null;
  }

  return (
    <div className="safety-iihs-ratings size-16">
      <Row className="mb-1_5">
        <Col xs={12}>
          <div className="heading-5 mb-0_5">IIHS Rating</div>
          <div>The Insurance Institute of Highway Safety uses extensive crash tests to determine car safety.</div>
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={8} lg={6}>
          <ul className="list-unstyled mb-0">
            {Object.keys(safetyMap.iihsRatings).map(ratingKey => {
              const ratingItemValue = iihsRatings[ratingKey];

              return (
                <Row tag="li" key={ratingKey} className="mb-0_5">
                  <Col className="pe-2">{safetyMap.iihsRatings[ratingKey]}</Col>
                  <Col className="pe-0_5" xs="auto">
                    {ratingItemValue ? (
                      <div
                        className={classnames('fw-bold', {
                          'text-success': ratingItemValue === 'Good',
                          'text-danger': ratingItemValue === 'Poor',
                          'text-warning': ratingItemValue === 'Marginal',
                          'text-warning-lighter': ratingItemValue === 'Acceptable',
                        })}
                      >
                        {ratingItemValue}
                      </div>
                    ) : (
                      <span>{'Not Tested'}</span>
                    )}
                  </Col>
                </Row>
              );
            })}
          </ul>
        </Col>
      </Row>
    </div>
  );
}

SafetyIihsRatings.propTypes = {
  iihsRatings: SafetyEntities.IihsRatings,
};

SafetyIihsRatings.defaultProps = {
  iihsRatings: null,
};
